import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { Constanst } from 'src/app/core/constants/constans.component';

@Component({
  selector: 'app-detalle-mano-obra-compuesta',
  templateUrl: './detalle-mano-obra-compuesta.component.html',
  styleUrls: ['./detalle-mano-obra-compuesta.component.css'],
  providers: [DatePipe]
})
export class DetalleManoObraCompuestaComponent implements OnInit {
  logoVisorWeb = Constanst.LOGO_VISOR_WEB;
  manoDeObraCompuestaForm: FormGroup;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  nroRegistros: number = this.data.nroRegistro;
  dialogTitle: string = this.data.dialogTitle;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe,
    private apiCallService: ApiCallService,
    public dialogDetalleManoDeObraCompuestaRef: MatDialogRef<DetalleManoObraCompuestaComponent>
  ) { }

  ngOnInit(): void {
    this.consultLaborDetails();
    this.manoDeObraCompuestaForm = new FormGroup ({
      reference: new FormControl({value: this.data.row.reference, disabled: true}),
      updateDate: new FormControl({value: this.datePipe.transform(this.data.row.updateDate, 'dd/MM/yyyy'), disabled: true}),
      description: new FormControl({value: this.data.row.description, disabled: true}),
      jornal: new FormControl({value: '', disabled: true}),
      bono: new FormControl({value: '', disabled: true}),
      laborGrouping: new FormControl({value: this.data.row.laborGrouping, disabled: true}),
      jornal$: new FormControl({value: '', disabled: true}),
      van: new FormControl({value: '', disabled: true}),
      contributesVan: new FormControl({value: false, disabled: true}),
      relateDollar: new FormControl({value: false, disabled: true}),
      instruction: new FormControl({value: '', disabled: true}),
      experience: new FormControl({value: this.data.row.experience, disabled: true}),
      requisiteExpertise: new FormControl({value: this.data.row.requisiteExpertise, disabled: true}),
      task: new FormControl({value: this.data.row.task, disabled: true}),
      commentary: new FormControl({value: this.data.row.commentary, disabled: true})
    });
  }

  consultLaborDetails() {
    this.route = '/getLaborDetailById';
    this.method = 'POST';
     let data = {
      idLabor: this.data.row.idLabor,
      idLaborZone: this.data.row.idLaborZone
     }

     this.apiCallService.call$(data, this.route, this.method, true, '', true)
     .pipe(takeUntil(this.destroy$)).subscribe(
      response => {
        //console.log(response);
        this.manoDeObraCompuestaForm = new FormGroup ({
          reference: new FormControl({value: response.data.laborEntity.reference, disabled: true}),
          updateDate: new FormControl({value: this.datePipe.transform(response.data.laborEntity.updateDate, 'dd/MM/yyyy'), disabled: true}),
          description: new FormControl({value: response.data.laborEntity.description, disabled: true}),
          jornal: new FormControl({value: response.data.laborZoneEntity.jornal, disabled: true}),
          bono: new FormControl({value: response.data.laborZoneEntity.price, disabled: true}),
          laborGrouping: new FormControl({value: this.data.row.laborGrouping, disabled: true}),
          jornal$: new FormControl({value: response.data.laborEntity.dollarPrice, disabled: true}),
          van: new FormControl({value: response.data.laborEntity.addedValue, disabled: true}),
          contributesVan: new FormControl({value: response.data.laborEntity.contributesVan, disabled: true}),
          relateDollar: new FormControl({value: response.data.laborEntity.relateDollar, disabled: true}),
          instruction: new FormControl({value: response.data.laborEntity.educationLevel, disabled: true}),
          experience: new FormControl({value: response.data.laborEntity.experience, disabled: true}),
          requisiteExpertise: new FormControl({value: response.data.laborEntity.requisiteExpertise, disabled: true}),
          task: new FormControl({value: response.data.laborEntity.task, disabled: true}),
          commentary: new FormControl({value: response.data.laborEntity.commentary, disabled: true})
        });
        this.apiCallService.hideSpinner();
      });
  }

  closeDialogDetalleManoDeObraCompuesta() {
    this.dialogDetalleManoDeObraCompuestaRef.close();
  }

}
